import { STATUS_COLORS, STATUS_LABELS } from "./constants";

export const getStatusBadgeColor = (status: string): string => {
	return (
		STATUS_COLORS[status as keyof typeof STATUS_COLORS] ||
		STATUS_COLORS.not_started
	);
};

export const getStatusLabel = (status: string): string => {
	return STATUS_LABELS[status] || status.replace("_", " ");
};

const sanitizeFilename = (title: string): string => {
	// Remove or replace characters that are not allowed in filenames
	return title
		.replace(/[<>:"/\\|?*]/g, "-") // Replace invalid characters with dash
		.replace(/\s+/g, " ") // Normalize whitespace
		.trim();
};

export const handlePrint = (
	checkAnalysisExists: () => boolean,
	onIncludeAnalysis: (include: boolean) => void,
	onShowPrintDialog: (show: boolean) => void,
	onSetPendingPrintAction: (action: (() => void) | null) => void,
	reflectionTitle?: string,
): void => {
	const hasAnalysis = checkAnalysisExists();

	const executePrint = () => {
		// Store original title and set custom title for PDF filename
		const originalTitle = document.title;
		if (reflectionTitle) {
			const sanitizedTitle = sanitizeFilename(reflectionTitle);
			document.title = `${sanitizedTitle} - Reflection Journal Report`;
		}

		// Reset after print dialog closes
		const handleAfterPrint = () => {
			// Restore original document title
			document.title = originalTitle;

			// Restore DOM visibility by removing print classes
			const tabsWrapper = document.getElementById("tabs-wrapper");
			const combinedContent = document.getElementById("print-combined");

			if (tabsWrapper) {
				tabsWrapper.classList.remove("print-hidden");
			}
			if (combinedContent) {
				combinedContent.classList.remove("print-visible");
			}

			onIncludeAnalysis(false);
			window.removeEventListener("afterprint", handleAfterPrint);
		};
		window.addEventListener("afterprint", handleAfterPrint);

		// Small delay to ensure print dialog opens
		setTimeout(() => {
			window.print();
		}, 50);
	};

	if (hasAnalysis) {
		// Show dialog to ask user if they want to include analysis
		onSetPendingPrintAction(() => executePrint);
		onShowPrintDialog(true);
	} else {
		onIncludeAnalysis(false);
		executePrint();
	}
};

export const handleSaveAsPDF = (
	checkAnalysisExists: () => boolean,
	onIncludeAnalysis: (include: boolean) => void,
	onShowPrintDialog: (show: boolean) => void,
	onSetPendingPrintAction: (action: (() => void) | null) => void,
	reflectionTitle?: string,
): void => {
	// Same as print - user can save as PDF with or without analysis
	handlePrint(
		checkAnalysisExists,
		onIncludeAnalysis,
		onShowPrintDialog,
		onSetPendingPrintAction,
		reflectionTitle,
	);
};
